<cgp-app-card titleText="Request Access Form">
   <div class="container-fluid mt-lg-3">
      <gm-loading-spinner *ngIf="loading"></gm-loading-spinner>
      <p>You do not have access to TPRECM.</p>
      <p>Enter a reason for requesting access to TPRECM.
         (i.e. Open Files and Create Reports, Update TPR Info, Update ECM info, etc...)</p>
      <mat-form-field appearance="fill" class="full-width">
         <mat-label>Reason</mat-label>
         <textarea #input matInput maxlength="128" rows="8" [formControl]="reason"></textarea>
      </mat-form-field>
      <span class="d-inline-flex align-items-center">
         <button class="mr-2" mat-button mat-raised-button color="primary" (click)="onSubmitClick()"
            (keypress.enter)="onSubmitClick()" [disabled]="reason.invalid || disabled || loading">Submit
            Request</button>
         <mat-icon *ngIf="reason.invalid" matTooltip="Reason cannot be empty." matTooltipPosition="right">help_outline
         </mat-icon>
      </span>
   </div>
</cgp-app-card>